import { useAuthContext } from "../../../../hooks/useAuthContext";
import { Column } from "primereact/column";
import useUrlState from "@ahooksjs/use-url-state";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import MeaButton from "../../../../components/MeaButton";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import MeaDataTable from "../../../../components/MeaDataTable";
import { BlockUI } from "primereact/blockui";
import CreateCourseModal from "./AddStudentModal";
import MeaStudentAvatar from "../../components/MeaStudentAvatar";
import studentsAPI from "../../../../services/students";
import MeaLink from "../../../../components/MeaLink";
import { useNavigate } from "react-router-dom";
import classesAPI from "../../../../services/classes";
import levelsAPI from "../../../../services/levels";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import UpdateStudentAffectationModal from "./UpdateStudentAffectationModal";
import CreateSlotChangeRequestModal from "../../slot-change-requests/components/CreateSlotChangeRequestModal";
import uiDataAPI from "../../../../services/ui_data";
import MeaStudentResult from "../../../../components/MeaStudentResult";
import { PERMISSION_TRAINING_CLASSES, PERMISSION_TRAINING_LEVELS, PERMISSION_TRAINING_SLOT_CHANGE_REQUESTS, PERMISSION_TRAINING_STUDENTS, PERMISSION_TRAINING_TASKS } from "../../../../permissions";
import { SplitButton } from "primereact/splitbutton";
import tasksAPI from "../../../../services/tasks";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { Toast } from "primereact/toast";
import { Tag } from "primereact/tag";
import { useMediaQuery } from "react-responsive";
import UpdateStudentResultObservationModal from "../models/UpdateStudentResultObservationModal";
import FamilyInfoModal from "../../../registrations/components/FamilyInfoModal";

const StudentsListComponent = forwardRef((props, ref) => {
  const {
    selectedFields,
    filter,
    showExportButton = false,
    showFilterButton,
    showFilter,
    schoolId,
    trainingId,
    familyColumnLabel = "Fichier élève",
    familyColumnIcon = "pi pi-file",
    familyColumnTooltip = "Voir le dossier élève",
    familyColumnTooltipOptions,
    showSlotChangeColumn = true,
    disableNavigation = false,
    openStudentSheetOnNameClick = false,
  } = props;
  const { hasPermission } = useAuthContext();
  //const [searchParams] = useSearchParams();
  //const search = searchParams.get("search");
  const navigate = useNavigate();

  const [page, setPage] = useState();
  const [pageSize, setPageSize] = useState();
  const [searchInputValue, setSearchInputValue] = useState(filter?.name || "");
  const [isSearchLoading, setIsSearchLoading] = useState(false);

  const accessToken = "";
  //
  const isMobile = useMediaQuery({
    query: '(max-width: 575px)'
  })
  //
  const createModalRef = useRef();
  const updateModalRef = useRef();
  const slotChangeModalRef = useRef();
  const updateResultObservationModalRef = useRef();
  const familyInfoModalRef = useRef();
  const searchInputRef = useRef();
  const [jobId, setJobId] = useState(null);
  const [student, setStudent] = useState(null);

  //
  let selectedData = {
    name: selectedFields?.name ?? true,
    age: selectedFields?.age ?? true,
    level: selectedFields?.level ?? true,
    classe: selectedFields?.classe ?? true,
    edit: selectedFields?.edit ?? true,
    passing: selectedFields?.passing ?? true,
    observation: selectedFields?.observation ?? true,
    absences: selectedFields?.absences ?? true,
    retards: selectedFields?.retards ?? true,
    allergies: selectedFields?.allergies ?? false,
    health_issues: selectedFields?.health_issues ?? false,
    authorized_take_photo: selectedFields?.authorized_take_photo ?? false,
    authorized_back_alone: selectedFields?.authorized_back_alone ?? false
  };
  //
  const [state, setState] = useUrlState({
    studentsPage: "1",
    studentsPageSize: "50",
    studentsFilter: JSON.stringify({
      level_id: filter?.level_id || "",
      classe_id: filter?.classe_id || "",
      name: filter?.name || "",
      result: filter?.result || "",
      min_absences: filter?.min_absences || "",
      min_retards: filter?.min_retards || "",
    }),
  });

  //
  const queryList = studentsAPI.useGetOngoingList(
    schoolId,
    trainingId,
    accessToken,
    page,
    pageSize,
    JSON.parse(state.studentsFilter)
  );
  const levelsQuery = levelsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  const classesQuery = classesAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000,
    {
      level_id: JSON.parse(state.studentsFilter)?.level_id,
    }
  );
  const UiDataStudentResultTypesListQuery = uiDataAPI.UiDataStudentResultTypesList(
    accessToken
  );
  //
  const toast = useRef(null);
  const studentsRef = useRef(null);
  //
  const STUDENT_RESULT_ONGOING = "ONGOING";           // En cours
  const STUDENT_RESULT_PASSED = "PASSED";             // Réussi
  const STUDENT_RESULT_FAILED = "FAILED";             // Redoublé
  //  
  const confirmChangeStudentsResults = (event, newStatus) => {
    // confirm to move selected students to the new status
    confirmPopup({
      target: event.currentTarget,
      message: 'Voulez-vous vraiment changer le score des élèves sélectionnés?',
      icon: 'pi pi-exclamation-triangle',
      defaultFocus: 'accept',
      accept: () => acceptUpdateResult(newStatus)  // Pass the newStatus to acceptUpdateResult
    });
  };
  const acceptUpdateResult = (newStatus) => {
    toast.current.show({ severity: 'info', summary: 'Confirmé', detail: 'Traitement en cours..' });
    let elements = studentsRef.current.getSelectedElements();
    tasksAPI.UpdateStudentsResult(schoolId, trainingId, accessToken, {
      students_ids: elements?.map((element) => {
        return element.id;
      }),
      new_result: newStatus,
    }).then((data) => {
      setJobId(data?.data?.id);
    }).catch((error) => {
      console.log("error", error);
    });
  };
  //
  const setFilter = (field, value) => {
    let currentFilter = state?.studentsFilter;
    let currentFilterObj = JSON.parse(currentFilter);
    currentFilterObj[field] = value;
    setState((s) => ({
      studentsPage: 1,
      studentsFilter: JSON.stringify(currentFilterObj),
    }));
  };
  const filterCombobox = (options, query, field) => {
    return (
      <Dropdown
        value={query?.data?.data?.find(
          (obj) => obj.id === JSON.parse(state.studentsFilter)[field]
        )}
        options={query?.data?.data}
        optionLabel="name"
        onChange={(e) => {
          options.filterApplyCallback(e.value);
          setFilter(field, e.value?.id || "");
        }}
        //itemTemplate={statusItemTemplate}
        placeholder="Séléctionner"
        className="p-column-filter"
        showClear
      />
    );
  };
  const filterMinCount = (options, field) => {
    const currentValue = JSON.parse(state.studentsFilter)[field];
    return (
      <InputNumber
        value={currentValue === "" ? null : Number(currentValue)}
        onValueChange={(e) => {
          const value = e.value ?? "";
          options.filterApplyCallback(value);
          setFilter(field, value);
        }}
        min={0}
        placeholder="Min."
        className="p-column-filter"
        showButtons={false}
      />
    );
  };
  //
  const setSearchName = (name) => {
    let currentFilter = state?.studentsFilter;
    let currentFilterObj = JSON.parse(currentFilter);
    currentFilterObj.name = name;
    setState((s) => ({
      studentsPage: 1,
      studentsFilter: JSON.stringify(currentFilterObj),
    }));
  };
  //
  const handleSearch = () => {
    setIsSearchLoading(true);
    setSearchName(searchInputValue);
  };
  //
  const handleClear = () => {
    const currentFilter = JSON.parse(state.studentsFilter);
    if (currentFilter?.name !== "") {
      setIsSearchLoading(true);
    }
    setSearchInputValue("");
    setSearchName("");
    
  };
  //
  useEffect(() => {
    const fetchTaskStatus = async () => {
      tasksAPI.GetTask(schoolId, trainingId, jobId, accessToken)
        .then((data) => {
          if (data?.data?.status === "COMPLETED") {

            toast.current.clear();
            toast.current.show({ severity: 'success', summary: 'Succès', detail: 'Traitement fini' });
            setJobId(null);
            queryList?.refetch();

          } else if (data?.data?.status === "FAILED") {

            toast.current.clear();
            toast.current.show({ severity: 'error', summary: 'Erreur', detail: 'Error lors du traitement!' });
            setJobId(null);

          }
          else {
            setTimeout(fetchTaskStatus, 1000); // Retry after 1 seconds
          }
        })
        .catch((error) => {
          console.log("error " + error);
          setJobId(null);

        });
    };

    if (jobId) {
      fetchTaskStatus();
    }

  }, [jobId, queryList, schoolId, trainingId]);
  //
  useImperativeHandle(ref, () => ({
    refresh: () => {
      queryList?.refetch();
    },
  }));
  //

  // Sync search input value with filter state
  useEffect(() => {
    const currentFilter = JSON.parse(state.studentsFilter);
    if (currentFilter?.name !== searchInputValue) {
      setSearchInputValue(currentFilter?.name || "");
    }    
  }, [state.studentsFilter]);

  // Reset search loading state when query data changes
  useEffect(() => {
    if (queryList?.data && !queryList?.isLoading) {
      setIsSearchLoading(false);
    }
  }, [queryList?.data, queryList?.isLoading]);

  //

  const startToolbarTemplate = (
    <>
      <span className="p-input-icon-left mr-2 " >
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText
            id="search"
            ref={searchInputRef}
            value={searchInputValue}
            onChange={(e) => setSearchInputValue(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
            placeholder="Chercher un(e) élève"
          />
        </IconField>
      </span>
      <MeaButton
        onClick={handleSearch}
        icon={isSearchLoading ? "pi pi-spinner pi-spin" : "pi pi-search"}
        disabled={isSearchLoading}
        loading={isSearchLoading}
      />
      {searchInputValue && (
        <MeaButton
          onClick={handleClear}
          icon="pi pi-times"
          outlined
          disabled={isSearchLoading}
          className="ml-2"
        />
      )}
    </>
  );
  const endToolbarTemplate = (
    <>
      {showExportButton && <MeaButton icon="pi pi-file-export" permission={PERMISSION_TRAINING_TASKS.EXPORT_STUDENTS_TO_EXCEL_FILE} label="Exporter" className="mr-2" outlined onClick={() => {
        navigate("/school/" + schoolId + "/admin/trainings/" + trainingId + "/export-students");
      }} />}
    </>
  );
  const selectedToolbarTemplate = (
    <>

      {hasPermission(PERMISSION_TRAINING_STUDENTS.UPDATE) && <SplitButton

        label="Admis"
        icon="pi pi-check bg-green"
        onClick={(event) => {
          confirmChangeStudentsResults(event, STUDENT_RESULT_PASSED)
        }}
        style={{ marginRight: '5px' }}
        severity="success"
        model={[
          {
            label: "Redoublement Recommandé",
            icon: "pi pi-exclamation-triangle",
            command: (event) => confirmChangeStudentsResults(event, STUDENT_RESULT_FAILED),
          },
          {
            label: "En Cours",
            icon: "pi pi-play",
            command: (event) => confirmChangeStudentsResults(event, STUDENT_RESULT_ONGOING),
          },
        ]}
      />}

    </>
  );
  //
  return (
    <>
      <CreateCourseModal ref={createModalRef} />
      <Toast position="bottom-center" ref={toast} />
      <ConfirmPopup />
      <UpdateStudentAffectationModal
        ref={updateModalRef}
        schoolId={schoolId}
        trainingId={trainingId}
      />
      <CreateSlotChangeRequestModal
        ref={slotChangeModalRef}
        schoolId={schoolId}
        trainingId={trainingId}
      />

      <BlockUI 
        blocked={isSearchLoading || queryList?.isLoading} 
      >
        <MeaDataTable
          ref={studentsRef}
          query={queryList}
          serviceAPI={studentsAPI}
          names={{
            pagination: "students",
            singular: "élève",
            plural: "élèves",
          }}
          startToolbarTemplate={startToolbarTemplate}
          endToolbarTemplate={endToolbarTemplate}
          selectedToolbarTemplate={selectedToolbarTemplate}
          showFilterButton={showFilterButton}
          showDeleteButton={false}
          showFilter={showFilter}
          //showDeleteButton={hasPermission(PERMISSION_TRAINING_STUDENTS.DELETE)}
          pageSize={state.studentsPageSize}
          setPage={setPage}
          setPageSize={setPageSize}
          paginatorPosition="both"
          scrollable={false}
          scrollHeight="auto"
          style={{ minWidth: isMobile ? '100%' : '50rem' }}
          schoolId={schoolId}
          trainingId={trainingId}
          rowClassName={(student) => (!student?.classe?.id ? 'bg-red-100' : '')}
        >
          <Column
            selectionMode="multiple"
            headerStyle={{ width: isMobile ? "2.5rem" : "3rem" }}
          ></Column>
          {selectedData.name && (
            <Column
              header="Elève"
              frozen={!isMobile}
              headerStyle={{ width: isMobile ? "auto" : "18rem", textAlign: "left" }}
              body={(student) => {
                return (
                  <div className="flex flex-column align-items-start gap-1 py-1">
                    <MeaStudentAvatar
                      student={student}
                      permission={PERMISSION_TRAINING_STUDENTS.GET}
                      schoolId={schoolId}
                      trainingId={trainingId}
                      noNavigation={disableNavigation}
                      onClick={openStudentSheetOnNameClick ? (item) => familyInfoModalRef.current?.show(item) : undefined}
                    />
                    <div className="sm:hidden flex flex-column gap-1 pl-5 text-xs text-600 w-full mt-1">
                      <div>Age : {student?.age ? `${student.age} ans` : "-"}</div>
                      <div>Photographié : {student?.authorized_take_photo ? "Oui" : "Non"}</div>
                      <div>Allergies : {student?.allergies || "-"}</div>
                      {selectedData.health_issues && (
                        <div>Problèmes de santé : {student?.health_issues || "-"}</div>
                      )}
                      <div>Sortie seul : {student?.authorized_back_alone ? "Oui" : "Non"}</div>
                      {selectedData.classe && student?.classe?.name && (
                        <div>Classe : {student.classe.name}</div>
                      )}
                      {selectedData.absences && (
                        <div>
                          Absences :{" "}
                          {(student?.absences_count ?? 0) > 0 ? (
                            <Tag severity="danger" value={student.absences_count} />
                          ) : (
                            0
                          )}
                        </div>
                      )}
                      {selectedData.retards && (
                        <div>
                          Retards :{" "}
                          {(student?.retards_count ?? 0) > 0 ? (
                            <Tag severity="warning" value={student.retards_count} />
                          ) : (
                            0
                          )}
                        </div>
                      )}
                      {student?.status !== "ENROLLED" && (
                        <div>Statut : Désinscrit</div>
                      )}
                    </div>
                  </div>
                );
              }}
            ></Column>
          )}
          <Column
            header={familyColumnLabel}
            headerStyle={{ textAlign: "center", width: isMobile ? "4.5rem" : "8rem" }}
            bodyStyle={{ textAlign: "center", width: isMobile ? "4.5rem" : "8rem" }}
            body={(item) => (
              <MeaButton
                icon={familyColumnIcon}
                tooltip={familyColumnTooltip}
                tooltipOptions={familyColumnTooltipOptions}
                className="p-button-text p-button-sm"
                onClick={() => {
                  if (familyInfoModalRef.current) {
                    familyInfoModalRef.current.show(item);
                  }
                }}
              />
            )}
          ></Column>
          {showSlotChangeColumn && (
            <Column
              header="Créneau"
              headerStyle={{ textAlign: "center", width: isMobile ? "4.5rem" : "6rem" }}
              bodyStyle={{ textAlign: "center" }}
              body={(item) => (
                hasPermission(PERMISSION_TRAINING_SLOT_CHANGE_REQUESTS.CREATE) ? (
                  <MeaButton
                    icon="pi pi-clock"
                    tooltip="Demande de changement de créneau"
                    className="p-button-text p-button-sm"
                    onClick={() => {
                      if (slotChangeModalRef.current) {
                        slotChangeModalRef.current.show(() => {
                          queryList.refetch();
                        }, item);
                      }
                    }}
                  />
                ) : null
              )}
            ></Column>
          )}
          {!isMobile && selectedData.age && (
            <Column
              header="Age"
              body={(student) => (
                <span>{student?.age || "-"}</span>
              )}
            ></Column>
          )}
          {!isMobile && selectedData.authorized_take_photo && (
            <Column
              header="Photographié"
              style={{ maxWidth: "200px" }}
              body={(student) => (
                <div className="text-700 mt-2">{student?.authorized_take_photo ? <span className="pi pi-check text-green-500 text-sm" >OUI</span> : <span className="pi pi-times text-red-500 text-sm" >NON</span>}</div>
              )}
            ></Column>
          )}
          {!isMobile && selectedData.allergies && (
            <Column
              header="Allergies"
              style={{ maxWidth: "200px" }}
              body={(student) => (
                <div className="overflow-hidden text-overflow-ellipsis">{student?.allergies || "-"}</div>
              )}
            ></Column>
          )}
          {!isMobile && selectedData.health_issues && (
            <Column
              header="Problèmes de santé"
              style={{ maxWidth: "220px" }}
              body={(student) => (
                <div className="overflow-hidden text-overflow-ellipsis">{student?.health_issues || "-"}</div>
              )}
            ></Column>
          )}
          {!isMobile && selectedData.authorized_back_alone && (
            <Column
              header="Partir seul"
              style={{ maxWidth: "200px" }}
              body={(student) => (
                <div className="text-700 mt-2">{student?.authorized_back_alone ? <span className="pi pi-check text-green-500 text-sm" >OUI</span> : <span className="pi pi-times text-red-500 text-sm">NON</span>}</div>
              )}
            ></Column>
          )}
          {!isMobile && selectedData.level && (
            <Column
              field="level"
              header="Niveau"
              body={(item) => (
                <MeaLink
                  to={
                    "/school/" +
                    schoolId +
                    "/admin/trainings/" +
                    trainingId +
                    "/levels/" +
                    item?.level?.id
                  }
                  permission={PERMISSION_TRAINING_LEVELS.GET}
                  noNavigation={disableNavigation}
                >
                  {item?.level?.name}
                </MeaLink>
              )}
              filter
              showFilterMenu={false}
              showClearButton={false}
              filterElement={(options) =>
                filterCombobox(options, levelsQuery, "level_id")
              }
            ></Column>
          )}
          {!isMobile && selectedData.classe && (
            <Column
              field="classe"
              header="Classe"
              body={(item) => (
                item?.classe?.id ? (
                  <MeaLink
                    to={
                      "/school/" +
                      schoolId +
                      "/admin/trainings/" +
                      trainingId +
                      "/classes/" +
                      item?.classe?.id
                    }
                    permission={PERMISSION_TRAINING_CLASSES.GET}
                    noNavigation={disableNavigation}
                  >
                    {item?.classe?.name}
                  </MeaLink>
                ) : (
                  <Tag severity="warning" value="Non affecté" />
                )
              )}
              filter
              showFilterMenu={false}
              showClearButton={false}
              filterElement={(options) => {
                const classFilterOptions = [
                  { id: "unassigned", name: "Non affecté" },
                  ...(classesQuery?.data?.data || []),
                ];
                return (
                  <Dropdown
                    value={classFilterOptions.find(
                      (obj) => obj.id === JSON.parse(state.studentsFilter)["classe_id"]
                    )}
                    options={classFilterOptions}
                    optionLabel="name"
                    onChange={(e) => {
                      options.filterApplyCallback(e.value);
                      setFilter("classe_id", e.value?.id || "");
                    }}
                    placeholder="Séléctionner"
                    className="p-column-filter"
                    showClear
                  />
                );
              }}
            ></Column>
          )}
          {!isMobile && selectedData.absences && (
            <Column
              field="absences_count"
              header="Absences"
              headerStyle={{ textAlign: "center", width: "7rem" }}
              bodyStyle={{ textAlign: "center" }}
              body={(student) =>
                (student?.absences_count ?? 0) > 0 ? (
                  <Tag severity="danger" value={student.absences_count} />
                ) : (
                  0
                )
              }
              filter
              showFilterMenu={false}
              showClearButton={false}
              filterElement={(options) => filterMinCount(options, "min_absences")}
            ></Column>
          )}
          {!isMobile && selectedData.retards && (
            <Column
              field="retards_count"
              header="Retards"
              headerStyle={{ textAlign: "center", width: "7rem" }}
              bodyStyle={{ textAlign: "center" }}
              body={(student) =>
                (student?.retards_count ?? 0) > 0 ? (
                  <Tag severity="warning" value={student.retards_count} />
                ) : (
                  0
                )
              }
              filter
              showFilterMenu={false}
              showClearButton={false}
              filterElement={(options) => filterMinCount(options, "min_retards")}
            ></Column>
          )}
          {!isMobile && selectedData.passing && (
            <Column
              field="result"
              header="Avis de passage"
              body={(item) => {
                return <MeaStudentResult student={item} />;
              }}
              filter
              showFilterMenu={false}
              showClearButton={false}
              filterElement={(options) =>
                filterCombobox(options, UiDataStudentResultTypesListQuery, "result")
              }
            ></Column>
          )}
          {!isMobile && selectedData.observation && (
            <Column
              field="result_observation"
              header="Observation"
              body={(item) => {
                return (
                  <div className="flex align-items-center justify-content-start">
                    <MeaButton
                      icon="pi pi-file-edit"
                      rounded
                      text
                      aria-label="Filter"
                      onClick={() => {
                        setStudent(item);
                        if (updateResultObservationModalRef.current) {
                          updateResultObservationModalRef.current.show(() => {
                            queryList.refetch();
                          });
                        }
                      }}
                      permission={PERMISSION_TRAINING_STUDENTS.UPDATE}
                    />
                    <div className="overflow-hidden text-overflow-ellipsis">{item?.result_observation || "-"}</div>
                  </div>
                );
              }}

            ></Column>
          )}


        </MeaDataTable>
      </BlockUI>
      <UpdateStudentResultObservationModal ref={updateResultObservationModalRef} student={student} schoolId={schoolId} trainingId={trainingId} />
      <FamilyInfoModal ref={familyInfoModalRef} schoolId={schoolId} trainingId={trainingId} />
    </>
  );
});

export default StudentsListComponent;
